import React from "react";
import SignInGoogleButton from "./SignInGoogleButton";
import SignInGitHubButton from "./SignInGitHubButton";
import SignInFacebookButton from "./SignInFacebookButton";
import SignInOauthGoogle from "./SignInOauthGoogle";

export default function OAuthPanel() {
  return (
    <>
      <SignInGoogleButton />
      <SignInGitHubButton />
      <SignInFacebookButton />
      {/* <SignInOauthGoogle /> */}
    </>
  );
}
